//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import ClientId from '@models/ClientId';
import Cuid from '@models/Cuid';
import { IRightsPermissions } from '@models/IItemMetadata';
import PartialCuid from '@models/PartialCuid';
import CommunicationType from '@models/RightsCommunicationType';
import { IRightsRequest } from '@uia/rights-request/rights-request-model';

import { RIGHTS_STATUS } from 'app/bulk-actions/bulk-actions-constants/bulk-actions-constants';

export interface IGetTermsAndConditions {
  data: {
    termsAndConditions: ITermsAndContions;
  };
}

export interface ITermsAndContions {
  termsAndConditionsUrl: string;
  isCustom: boolean;
}

export interface MarkRightsApprovedRequest {
  cuids: PartialCuid[];
  // Backend expeects a number. Used as a Date otherwise
  expirationTime?: number;
}

export type MarkRightsApprovedResponse = Record<
  PartialCuid,
  IRightsPermissions
>;

export interface SkipRightsRequest {
  cuids: PartialCuid[];
}

export interface InitiateRightsRequestRequest {
  approvalPhrase?: string;
  communicationType?: RightsRequestCommunicationType;
  requestMessage?: string;
}

export interface InitiateRightsRequestResponse {
  data: boolean;
}

export interface RightsCapabilitiesResponse {
  isCapable: boolean;
}

export interface RightsConfigurationsRequest {
  networkItemId: PartialCuid | undefined;
}

export interface RightsAccount {
  accountId: string;
}

export type RightsConfigurationsResponse = IRightsOption[];

export interface SyndicatedContentStatusRequest {
  creatorClientId: ClientId;
  cuid: Cuid;
}

export interface SyndicatedContentStatusResponse {
  isSyndicated: boolean;
}

export type HistoricalUrlsResponse = TermsAndConditions[];

export interface TermsAndConditions {
  termsAndConditionsUrl: string;
  isCustom: boolean;
}

// TODO: PD-263920: The frontend CommunicationType appears to just be a tiny type that is casted as "DM"
export interface IMultiHandleRightsRequestApiResponse {
  approvalPhrase?: string;
  communicationType: CommunicationType;
  requestMessage?: string;
  status: RIGHTS_STATUS;
}

export interface IMultiHandleRightsGraphApiRequest {
  partialCuid: PartialCuid;
  params: IRightsRequest;
}

export interface IRightsCapabilitiesMultiHandleResponse {
  isRightsCapable: boolean;
}

export enum RightsRequestCommunicationType {
  BV_CREATORS_CAMPAIGN = 'BV_CREATORS_CAMPAIGN',
  BV_SAMPLING_CAMPAIGN = 'BV_SAMPLING_CAMPAIGN',
  COMMENT = 'COMMENT',
  DM = 'DM',
}
